import DashboardNavbar from "../../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../Components/LayoutContainers/DashboardLayout";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import React, {useEffect, useLayoutEffect, useState} from "react";
import {useFormik} from "formik";
import MDBox from "../../../Components/MDBox";
import {ButtonBase, Grid} from "@mui/material";
import MDInput from "../../../Components/MDInput";
import MDSelect from "../../../Components/MDSelect";
import MDDate from "../../../Components/MDDate";
import MDTypography from "../../../Components/MDTypography";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import * as Yup from 'yup';
import {ErrorToaast, SuccessToaast} from "../../../utils/toast/Toast";
import Cookies from "js-cookie";
import {StudentSalamatModel} from "../../../Api/Model/StudentLifeStyle";
import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import ESLM from "../../../Asset/images/ESLM.png";
import ESLF from "../../../Asset/images/ESLF.png";
import El1 from "../../../Asset/images/EL1.png";
import El2 from "../../../Asset/images/El2.png";
import El3 from "../../../Asset/images/El3.png";
import El4 from "../../../Asset/images/El4.png";
import LFFEImage from "../../../Asset/images/lsmac.png";
import LFMAImage from "../../../Asset/images/lsfac.png";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import {useNavigate} from "react-router-dom";


const validationSchema = Yup.object().shape({
    VadeGhaza: Yup.string().required('میزان وعده‌های غذایی   الزامی است'),
    VadeHajm: Yup.string().required('حجم مصرف غذایی   الزامی است'),
    VaziatTaghzie: Yup.string().required('وضعیت تغذیه   الزامی است'),
    Eshteha: Yup.string().required('سطح اشتها   الزامی است'),
    RezhimKhas: Yup.string().required('رژیم خاص   الزامی است'),
    Khab: Yup.string().required('میزان خواب   الزامی است'),
    Badani: Yup.string().required('وضعیت بدنی   الزامی است'),
    MianginBadani: Yup.string().required('میانگین   الزامی است'),
    Moghabeli: Yup.string().required('توانایی مقابله   الزامی است'),
    Varzesh: Yup.string().required('میزان ورزش   الزامی است'),
    Ezterab: Yup.string().required('سطح اضطراب   الزامی است'),
    Khashm: Yup.string().required('سطح خشمی   الزامی است'),
    BadKholgh: Yup.string().required('سطح بدخلقی   الزامی است'),
    Bihoslgi: Yup.string().required('سطح بی‌حوصلگی   الزامی است'),
    EstresStatus: Yup.string().required('وضعیت استرس   الزامی است'),
    BarnameRizi: Yup.string().required('برنامه‌ریزی روزانه   الزامی است'),
    Taroz: Yup.string().required('تعادل غذایی   الزامی است'),
    Ravabet: Yup.string().required('روابط اجتماعی   الزامی است'),
    RezayatKh: Yup.string().required('رضایت از زندگی خانگی   الزامی است'),
    Tahsil: Yup.string().required('سطح تحصیلات   الزامی است'),
    FastfoodHafte: Yup.string().required('میزان مصرف فست فود در هفته الزامی است'),
    ShiriniHafte: Yup.string().required('میزان مصرف شیرینی در هفته الزامی است'),
    SabziHafte: Yup.string().required('میزان مصرف سبزیجات در هفته الزامی است'),
    AbmiveHafte: Yup.string().required('میزان مصرف آبمیوه در هفته الزامی است'),
    EnergyzaHafte: Yup.string().required('میزان مصرف نوشیدنی انرژی‌زا در هفته الزامی است'),
    DelesterHafte: Yup.string().required('میزان مصرف دلستر در هفته الزامی است'),
    NooshabeHafte: Yup.string().required('میزان مصرف نوشابه در هفته الزامی است'),
    PcHafte: Yup.string().required('میزان استفاده از کامپیوتر در هفته الزامی است'),
    MobileHafte: Yup.string().required('میزان استفاده از موبایل در هفته الزامی است'),
    TvHafte: Yup.string().required('میزان استفاده از تلویزیون در هفته الزامی است'),
    Taalol: Yup.string().required('سطح تعلل   الزامی است'),
    Behdasht: Yup.string().required('وضعیت بهداشت و سلامت   الزامی است'),
    RabteDustan: Yup.string().required('روابط دوستانه   الزامی است'),
    Tozihat: Yup.string().required('توضیحات تکمیلی   الزامی است')
});
const steps = [
    'وضعیت تغذیه',
    'فعالیت بدنی',
    'عادت های روزانه',
    'وضعیت خلق و خو'
];

export default function LifeStyleStudent() {
    const [activeStep, setActiveStep] = React.useState(null);
    const [miniStep, setMiniStep] = React.useState(0);
    const navigate = useNavigate();
    const [controller, dispatch] = useMaterialUIController();
    const [isNew, setIsnew] = useState(true)
    var Api = new StudentSalamatModel(Cookies.get("cst") ?? "");

    const {loading} = controller;

    const formik = useFormik({
        initialValues: {
            VadeGhaza: '',
            VadeHajm: '',
            VaziatTaghzie: '',
            Eshteha: '',
            RezhimKhas: '',
            FastfoodHafte: '',
            ShiriniHafte: '',
            SabziHafte: '',
            AbmiveHafte: '',
            EnergyzaHafte: '',
            DelesterHafte: '',
            NooshabeHafte: '',
            PcHafte: '',
            MobileHafte: '',
            TvHafte: '',
            Khab: '',
            Badani: '',
            MianginBadani: '',
            Moghabeli: '',
            Varzesh: '',
            Ezterab: '',
            Khashm: '',
            BadKholgh: '',
            Bihoslgi: '',
            EstresStatus: '',
            BarnameRizi: '',
            Taroz: '',
            Ravabet: '',
            RezayatKh: '',
            Tahsil: '',
            Taalol: '',
            Behdasht: '',
            RabteDustan: '',
            BarnameKar: '',
            Tozihat: ''

        },
        validationSchema: validationSchema,

        onSubmit: (values) => {
            Api.Create({
                VadeGhaza: values.VadeGhaza,
                VadeHajm: values.VadeHajm,
                VaziatTaghzie: values.VaziatTaghzie.toString(),
                Eshteha: values.Eshteha,
                RezhimKhas: values.RezhimKhas,
                FastfoodHafte: values.FastfoodHafte,
                ShiriniHafte: values.ShiriniHafte,
                SabziHafte: values.SabziHafte,
                AbmiveHafte: values.AbmiveHafte,
                EnergyzaHafte: values.EnergyzaHafte,
                DelesterHafte: values.DelesterHafte,
                NooshabeHafte: values.NooshabeHafte,
                PcHafte: values.PcHafte,
                MobileHafte: values.MobileHafte,
                TvHafte: values.TvHafte,
                Khab: values.Khab,
                Badani: values.Badani,
                MianginBadani: values.MianginBadani,
                Moghabeli: values.Moghabeli,
                Varzesh: values.Varzesh.toString(),
                Ezterab: values.Ezterab,
                Khashm: values.Khashm,
                BadKholgh: values.BadKholgh,
                Bihoslgi: values.Bihoslgi,
                EstresStatus: values.EstresStatus,
                BarnameRizi: values.BarnameRizi,
                Taroz: values.Taroz,
                Ravabet: values.Ravabet,
                RezayatKh: values.RezayatKh,
                Tahsil: values.Tahsil,
                Taalol: values.Taalol,
                Behdasht: values.Behdasht,
                RabteDustan: values.RabteDustan,
                Tozihat: values.Tozihat,
                BarnameKar: values.barnameKar,
            }).then(response => {
                setLoading(dispatch, false)
                handleChangeMStep()

                SuccessToaast("اطلاعات شما با موفقیت ثبت شد! مدال‌ها و امتیازهای شما بروزرسانی گردید.")
            })
                .catch(error => {
                    ErrorToaast("خطا در ثبت اطلاعات");
                    setLoading(dispatch, false);
                });

        }
    })
    useLayoutEffect(() => {
        setLoading(dispatch, true)
        Api.Get()
            .then(r => {
                if (r.data.data !== null) {
                    setIsnew(false)
                    let model = r.data.data;
                    formik.setValues({
                        VadeGhaza: model.vadeGhaza,
                        VadeHajm: model.vadeHajm,
                        VaziatTaghzie: model.vaziatTaghzie,
                        Eshteha: model.eshteha,
                        RezhimKhas: model.rezhimKhas,
                        Khab: model.khab,
                        Badani: model.badani,
                        MianginBadani: model.mianginBadani,
                        Moghabeli: model.moghabeli,
                        Varzesh: model.varzesh,
                        FastfoodHafte: model.fastfoodHafte,
                        ShiriniHafte: model.shiriniHafte,
                        SabziHafte: model.sabziHafte,
                        AbmiveHafte: model.abmiveHafte,
                        EnergyzaHafte: model.energyzaHafte,
                        DelesterHafte: model.delesterHafte,
                        NooshabeHafte: model.nooshabeHafte,
                        PcHafte: model.pcHafte,
                        MobileHafte: model.mobileHafte,
                        TvHafte: model.tvHafte,
                        Ezterab: model.ezterab,
                        Khashm: model.khashm,
                        BadKholgh: model.badKholgh,
                        Bihoslgi: model.bihoslgi,
                        EstresStatus: model.estresStatus,
                        BarnameRizi: model.barnameRizi,
                        Taroz: model.taroz,
                        Ravabet: model.ravabet,
                        RezayatKh: model.rezayatKh,
                        Tahsil: model.tahsil,
                        Taalol: model.taalol,
                        Behdasht: model.behdasht,
                        RabteDustan: model.rabteDustan,
                        Tozihat: model.tozihat,

                    })
                }
                setLoading(dispatch, false)
            })
            .catch(r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })

    }, [])
    const totalSteps = () => {
        return steps.length;
    };
    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const handleNext = () => {
        setActiveStep(newActiveStep);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step) => () => {
        setActiveStep(step);
        switch (step) {
            case 0:
                setMiniStep(0)
                break;
            case 1:
                setMiniStep(5)
                break;
            case 2:
                setMiniStep(7)
                break;
            case 3:
                setMiniStep(10)
                break;
        }
    };

    function handleNextStep() {
        if (miniStep === 14) {
            formik.handleSubmit()
            return;
        }
        handleChangeMStep()
    }

    function handleChangeMStep() {
        if (miniStep === 15) {
            setActiveStep(null)
            setMiniStep(0)

            return;
        }
        if ([4, 6, 9].includes(miniStep)) {
            setActiveStep(c => c + 1)

        }
        setMiniStep(c => c + 1)
    }

    function handleBazgasht() {
        setMiniStep(0)
        setActiveStep(null)
    }

    return (
        <HeroLayout Showdesc={![4, 6, 9, 15].includes(miniStep)}>
            {![4, 6, 9, 15].includes(miniStep) ? <>
                <MDBox mx={{xs: 2, md: 10, xl: 10}} mt={4} component="form" role="form" onSubmit={formik.handleSubmit}>
                    <MDBox sx={{justifySelf: "center"}}>
                        <img src={CurrentUser().user.Sex === "F" ? ESLF : ESLM} style={{height: "15vh"}}/>
                    </MDBox>
                    {activeStep == null && <>

                        <MDBox sx={{justifySelf: "center"}} pb={5}>
                            <Grid container textAlign={"center"} gap={5} mt={5}>
                                <Grid item xs={12} sx={{cursor: "pointer"}}
                                      onClick={() => setActiveStep(0) && setMiniStep(0)}>
                                    <img src={El1} style={{height: "30vh"}}/>
                                </Grid>
                                <Grid item xs={12} sx={{cursor: "pointer"}}
                                      onClick={() => (setActiveStep(1) & setMiniStep(5))}>
                                    <img src={El2} style={{height: "30vh"}}/>
                                </Grid>
                                <Grid item xs={12} sx={{cursor: "pointer"}}
                                      onClick={() => (setActiveStep(2) & setMiniStep(7))}>
                                    <img src={El3} style={{height: "30vh"}}/>
                                </Grid>
                                <Grid item xs={12} sx={{cursor: "pointer"}}
                                      onClick={() => (setActiveStep(3) & setMiniStep(10))}>
                                    <img src={El4} style={{height: "30vh"}}/>
                                </Grid>
                                <Grid item xs={12} sx={{cursor: "pointer"}}
                                      onClick={() => navigate("/studentlanding")}>
                                    <MDTypography sx={{fontSize: "40px"}}>بازگشت</MDTypography>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </>
                    }
                    <MDTypography sx={{
                        justifySelf: "center",
                        fontSize: "2rem",
                        color: "#005CB1",
                        fontFamily: "lale",
                        fontWeight: "bold"
                    }}>
                        {steps[activeStep]}
                    </MDTypography>
                    {activeStep != null && <>
                        <MDBox sx={{
                            width: {xs: "100%", md: "100%", xl: "50%"},
                            minHeight: "50vh",
                            justifySelf: "center",
                            background: "white",
                            border: "1px solid #00000073",
                            borderRadius: "10px",
                            px: {xs: 1, md: 1, xl: 10},
                            py: 5
                        }}>
                            <Grid container spacing={10}>
                                {miniStep === 0 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="VadeGhaza"
                                            name="VadeGhaza"
                                            value={formik.values.VadeGhaza}
                                            onChange={(r) => formik.setFieldValue("VadeGhaza", r)}
                                            error={
                                                Boolean(formik.errors.VadeGhaza)
                                            }
                                            helperText={formik.errors.VadeGhaza}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", xl: "100%",}}
                                            label={"تعداد وعده‌های غذایی در روز"}>
                                            <option value={"1"}>۱ وعده در روز</option>
                                            <option value={"2"}>۲ وعده در روز</option>
                                            <option value={"3"}>۳ وعده در روز</option>
                                            <option value={"4"}>۴ وعده در روز</option>
                                            <option value={"5"}>۵ وعده در روز و بیشتر</option>
                                        </MDSelect>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDInput
                                            id="VadeHajm"
                                            name="VadeHajm"
                                            value={formik.values.VadeHajm}
                                            onChange={formik.handleChange}
                                            error={
                                                Boolean(formik.errors.VadeHajm)
                                            }
                                            helperText={formik.errors.VadeHajm}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            // width={"200px"}
                                            sx={{width: {xs: "100%", md: "100%", xl: "100%",}}}
                                            label={"حجم هر وعده"}/>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="VaziatTaghzie"
                                            name="VaziatTaghzie"
                                            value={formik.values.VaziatTaghzie}
                                            onChange={(r) => formik.setFieldValue("VaziatTaghzie", r)}
                                            error={
                                                Boolean(formik.errors.VaziatTaghzie)
                                            }
                                            helperText={formik.errors.VaziatTaghzie}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", xl: "100%",}}
                                            label={"تعداد وعده‌های غذای خانگی سالم در هفته"}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"1"}>1-3 بار در هفته</option>
                                            <option value={"2"}>3-5 بار در هفته</option>
                                            <option value={"3"}>6-9 بار در هفته</option>
                                            <option value={"4"}>10 بار در هفته و بیشتر</option>

                                        </MDSelect>
                                    </Grid>
                                </>}
                                {miniStep === 1 && <>
                                    <Grid item xs={12}>
                                        <MDInput
                                            id="Eshteha"
                                            name="Eshteha"
                                            value={formik.values.Eshteha}
                                            onChange={formik.handleChange}
                                            error={
                                                Boolean(formik.errors.Eshteha)
                                            }
                                            helperText={formik.errors.Eshteha}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            // width={"200px"}
                                            sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                            label={"وضعیت اشتها"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDInput
                                            id="RezhimKhas"
                                            name="RezhimKhas"
                                            value={formik.values.RezhimKhas}
                                            onChange={formik.handleChange}
                                            error={
                                                Boolean(formik.errors.RezhimKhas)
                                            }
                                            helperText={formik.errors.RezhimKhas}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            // width={"200px"}
                                            sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                            label={"رژیم غذایی خاص"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="FastfoodHafte"
                                            name="FastfoodHafte"
                                            value={formik.values.FastfoodHafte}
                                            onChange={(r) => formik.setFieldValue("FastfoodHafte", r)}
                                            error={
                                                Boolean(formik.errors.FastfoodHafte)
                                            }
                                            helperText={formik.errors.FastfoodHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"دفعات استفاده از فست فود (چند بار درهفته)"}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"1"}>1 بار در هفته</option>
                                            <option value={"2"}>2 بار در هفته</option>
                                            <option value={"3"}>3 بار در هفته</option>
                                            <option value={"4"}>4 بار در هفته و بیشتر</option>
                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 2 && <>


                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="ShiriniHafte"
                                            name="ShiriniHafte"
                                            value={formik.values.ShiriniHafte}
                                            onChange={(r) => formik.setFieldValue("ShiriniHafte", r)}
                                            error={
                                                Boolean(formik.errors.ShiriniHafte)
                                            }
                                            helperText={formik.errors.ShiriniHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"دفعات استفاده از شیرینی و شکلات (چند بار درهفته)"}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"1"}>1-2 بار در هفته</option>
                                            <option value={"2"}>3-4 بار در هفته</option>
                                            <option value={"3"}>5 بار در هفته و بیشتر</option>


                                        </MDSelect>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="SabziHafte"
                                            name="SabziHafte"
                                            value={formik.values.SabziHafte}
                                            onChange={(r) => formik.setFieldValue("SabziHafte", r)}
                                            error={
                                                Boolean(formik.errors.SabziHafte)
                                            }
                                            helperText={formik.errors.SabziHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"دفعات استفاده از میوه و سبزیجات (چند بار درهفته)"}>
                                            <option value={"1"}>کمتر از ۳ بار</option>
                                            <option value={"2"}>۳-۴ بار در هفته</option>
                                            <option value={"3"}>۵-۶ بار در هفته</option>
                                            <option value={"4"}>هر روز</option>


                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="NooshabeHafte"
                                            name="NooshabeHafte"
                                            value={formik.values.NooshabeHafte}
                                            onChange={(r) => formik.setFieldValue("NooshabeHafte", r)}
                                            error={
                                                Boolean(formik.errors.NooshabeHafte)
                                            }
                                            helperText={formik.errors.NooshabeHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان مصرف نوشابه و نوشیدنی صنعتی در هفته "}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"1"}>1 بار در هفته</option>
                                            <option value={"2"}>2 بار در هفته</option>
                                            <option value={"3"}>3بار در هفته و بیشتر</option>


                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 3 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="EnergyzaHafte"
                                            name="EnergyzaHafte"
                                            value={formik.values.EnergyzaHafte}
                                            onChange={(r) => formik.setFieldValue("EnergyzaHafte", r)}
                                            error={
                                                Boolean(formik.errors.EnergyzaHafte)
                                            }
                                            helperText={formik.errors.EnergyzaHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان مصرف انرژی زا در هفته "}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"یکبار درهفته"}>یکبار درهفته</option>
                                            <option value={"2 یا 3 بار در هفته "}>2 یا 3 بار در هفته</option>
                                            <option value={"بیشتر از 3 بار"}>بیشتر از 3 بار</option>


                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="DelesterHafte"
                                            name="DelesterHafte"
                                            value={formik.values.DelesterHafte}
                                            onChange={(r) => formik.setFieldValue("DelesterHafte", r)}
                                            error={
                                                Boolean(formik.errors.DelesterHafte)
                                            }
                                            helperText={formik.errors.DelesterHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان مصرف دلستر در هفته "}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"یکبار درهفته"}>یکبار درهفته</option>
                                            <option value={"2 یا 3 بار در هفته "}>2 یا 3 بار در هفته</option>
                                            <option value={"بیشتر از 3 بار"}>بیشتر از 3 بار</option>


                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="AbmiveHafte"
                                            name="AbmiveHafte"
                                            value={formik.values.AbmiveHafte}
                                            onChange={(r) => formik.setFieldValue("AbmiveHafte", r)}
                                            error={
                                                Boolean(formik.errors.AbmiveHafte)
                                            }
                                            helperText={formik.errors.AbmiveHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان مصرف آبمیوه در هفته "}>
                                            <option value={"عدم مصرف"}>عدم مصرف</option>
                                            <option value={"یکبار درهفته"}>یکبار درهفته</option>
                                            <option value={"2 یا 3 بار در هفته "}>2 یا 3 بار در هفته</option>
                                            <option value={"بیشتر از 3 بار"}>بیشتر از 3 بار</option>


                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 5 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Badani"
                                            name="Badani"
                                            value={formik.values.Badani}
                                            onChange={(r) => formik.setFieldValue("Badani", r)}
                                            error={
                                                Boolean(formik.errors.Badani)
                                            }
                                            helperText={formik.errors.Badani}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان فعالیت بدنی در هفته"}>
                                            <option value={"0"}>کمتر از ۳ روز در هفته</option>
                                            <option value={"1"}>۳-۴ روز در هفته</option>
                                            <option value={"2"}>۵ روز در هفته</option>
                                            <option value={"3"}>۶-۷ روز در هفته</option>
 
                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="MianginBadani"
                                            name="MianginBadani"
                                            value={formik.values.MianginBadani}
                                            onChange={(r) => formik.setFieldValue("MianginBadani", r)}
                                            error={
                                                Boolean(formik.errors.MianginBadani)
                                            }
                                            helperText={formik.errors.MianginBadani}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میانگین زمان فعالیت بدنی روزانه"}>
                                            <option value={"0"}>کمتر از ۱۵ دقیق در روز</option>
                                            <option value={"1"}>بین ۱۵ تا ۳۰ دقیقه در روز</option>
                                            <option value={"2"}>بین ۳۰ تا ۶۰ دقیقه در روز</option>
                                            <option value={"3"}>بیشتر از ۶۰ دقیقه در روز</option>
                                      

                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Varzesh"
                                            name="Varzesh"
                                            value={formik.values.Varzesh}
                                            onChange={(r) => formik.setFieldValue("Varzesh", r)}
                                            error={
                                                Boolean(formik.errors.Varzesh)
                                            }
                                            helperText={formik.errors.Varzesh}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"سابقه ورزش"}>
                                            <option value={"دارم"}>دارم</option>
                                            <option value={"ندارم"}>ندارم</option>

                                        </MDSelect>
                                    </Grid>
                                </>}
                                {miniStep === 7 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Khab"
                                            name="Khab"
                                            value={formik.values.Khab}
                                            onChange={(r) => formik.setFieldValue("Khab", r)}
                                            error={
                                                Boolean(formik.errors.Khab)
                                            }
                                            helperText={formik.errors.Khab}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"وضعیت خواب"}>
                                            <option value={"کاملاً منظم"}>کاملاً منظم</option>
                                            <option value={"نسبتاً منظم"}>نسبتاً منظم</option>
                                            <option value={"نامنظم"}>نامنظم</option>
                                            <option value={"بسیار نامنظم"}>بسیار نامنظم</option>

                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDInput
                                            id="Tahsil"
                                            name="Tahsil"
                                            value={formik.values.Tahsil}
                                            onChange={formik.handleChange}
                                            error={
                                                Boolean(formik.errors.Tahsil)
                                            }
                                            helperText={formik.errors.Tahsil}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            // width={"200px"}
                                            sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                            label={"وضعیت تحصیلی"}/>
                                    </Grid>
                                </>}
                                {miniStep === 8 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="PcHafte"
                                            name="PcHafte"
                                            value={formik.values.PcHafte}
                                            onChange={(r) => formik.setFieldValue("PcHafte", r)}
                                            error={
                                                Boolean(formik.errors.PcHafte)
                                            }
                                            helperText={formik.errors.PcHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان استفاده روزانه از کامپیوتر یا لپ تاپ"}>
                                            <option value={"1"}>کمتر از ۱ ساعت در روز</option>
                                            <option value={"2"}>۱تا ۱.۵ ساعت در روز</option>
                                            <option value={"3"}>۱.۵تا ۲ ساعت در روز</option>
                                            <option value={"4"}>بیشتر از ۲ ساعت در روز</option>
 
                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="MobileHafte"
                                            name="MobileHafte"
                                            value={formik.values.MobileHafte}
                                            onChange={(r) => formik.setFieldValue("MobileHafte", r)}
                                            error={
                                                Boolean(formik.errors.MobileHafte)
                                            }
                                            helperText={formik.errors.MobileHafte}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان استفاده روزانه از تبلت یا موبایل"}>
                                            <option value={"1"}>کمتر از ۱ ساعت در روز</option>
                                            <option value={"2"}>۱تا ۱.۵ ساعت در روز</option>
                                            <option value={"3"}>۱.۵تا ۲ ساعت در روز</option>
                                            <option value={"4"}>بیشتر از ۲ ساعت در روز</option>
                                        </MDSelect>

                                    </Grid> <Grid item xs={12}>
                                    <MDSelect
                                        id="TvHafte"
                                        name="TvHafte"
                                        value={formik.values.TvHafte}
                                        onChange={(r) => formik.setFieldValue("TvHafte", r)}
                                        error={
                                            Boolean(formik.errors.TvHafte)
                                        }
                                        helperText={formik.errors.TvHafte}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        w={{xs: "100%", md: "100%", lg: "100%",}}
                                        label={"میزان استفاده روزانه از تلویزیون "}>
                                        <option value={"1"}>کمتر از ۱ ساعت در روز</option>
                                        <option value={"2"}>۱تا ۱.۵ ساعت در روز</option>
                                        <option value={"3"}>۱.۵تا ۲ ساعت در روز</option>
                                        <option value={"4"}>بیشتر از ۲ ساعت در روز</option>
                                    </MDSelect>

                                </Grid>
                                </>}
                                {miniStep === 10 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Ezterab"
                                            name="Ezterab"
                                            value={formik.values.Ezterab}
                                            onChange={(r) => formik.setFieldValue("Ezterab", r)}
                                            error={
                                                Boolean(formik.errors.Ezterab)
                                            }
                                            helperText={formik.errors.Ezterab}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان اضطراب "}>
                                            <option value={"بدون اضطراب"}>بدون اضطراب</option>
                                            <option value={"اضطراب کم"}>اضطراب کم</option>
                                            <option value={"اضطراب متوسط"}>اضطراب متوسط</option>
                                            <option value={"اضطراب زیاد"}>اضطراب زیاد</option>

                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Khashm"
                                            name="Khashm"
                                            value={formik.values.Khashm}
                                            onChange={(r) => formik.setFieldValue("Khashm", r)}
                                            error={
                                                Boolean(formik.errors.Khashm)
                                            }
                                            helperText={formik.errors.Khashm}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان  خشم"}>
                                            <option value={"بدون خشم"}>بدون خشم</option>
                                            <option value={"خشم کم"}>خشم کم</option>
                                            <option value={"خشم متوسط"}>خشم متوسط</option>
                                            <option value={"خشم زیاد"}>خشم زیاد</option>

                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="BadKholgh"
                                            name="BadKholgh"
                                            value={formik.values.BadKholgh}
                                            onChange={(r) => formik.setFieldValue("BadKholgh", r)}
                                            error={
                                                Boolean(formik.errors.BadKholgh)
                                            }
                                            helperText={formik.errors.BadKholgh}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان عصبی و بدخلق بودن"}>
                                            <option value={"آرام"}>آرام</option>
                                            <option value={"گاهی عصبی و بدخلق"}>گاهی عصبی و بدخلق</option>
                                            <option value={"معمولاً عصبی و بدخلق"}>معمولاً عصبی و بدخلق</option>
                                            <option value={"همیشه عصبی و بدخلق"}>همیشه عصبی و بدخلق</option>

                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 11 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Bihoslgi"
                                            name="Bihoslgi"
                                            value={formik.values.Bihoslgi}
                                            onChange={(r) => formik.setFieldValue("Bihoslgi", r)}
                                            error={
                                                Boolean(formik.errors.Bihoslgi)
                                            }
                                            helperText={formik.errors.Bihoslgi}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%"}}
                                            label={"میزان بی حوصلگی"}>
                                            <option value={"بسیار"}>بسیار پرانرژی</option>
                                            <option value={"گاهی"}>گاهی بی‌حوصله</option>
                                            <option value={"اغلب"}>اغلب بی‌حوصله</option>
                                            <option value={"کاملا"}>کاملاً بی‌حوصله</option>
                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="EstresStatus"
                                            name="EstresStatus"
                                            value={formik.values.EstresStatus}
                                            onChange={(r) => formik.setFieldValue("EstresStatus", r)}
                                            error={
                                                Boolean(formik.errors.EstresStatus)
                                            }
                                            helperText={formik.errors.EstresStatus}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"وضعیت استرس"}>
                                            <option value={"بدون استرس"}>بدون استرس</option>
                                            <option value={"استرس کم"}>استرس کم</option>
                                            <option value={"استرس متوسط"}>استرس متوسط</option>
                                            <option value={"استرس زیاد"}>استرس زیاد</option>

                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Taroz"
                                            name="Taroz"
                                            value={formik.values.Taroz}
                                            onChange={(r) => formik.setFieldValue("Taroz", r)}
                                            error={
                                                Boolean(formik.errors.Taroz)
                                            }
                                            helperText={formik.errors.Taroz}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان تعارض و اختلافات در خانواده"}>
                                            <option value={"بدون تعارض"}>بدون تعارض</option>
                                            <option value={"تعارض کم"}>تعارض کم</option>
                                            <option value={"تعارض متوسط"}>تعارض متوسط</option>
                                            <option value={"تعارض زیاد"}>تعارض زیاد</option>
                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 12 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="BarnameRizi"
                                            name="BarnameRizi"
                                            value={formik.values.BarnameRizi}
                                            onChange={(r) => formik.setFieldValue("BarnameRizi", r)}
                                            error={
                                                Boolean(formik.errors.BarnameRizi)
                                            }
                                            helperText={formik.errors.BarnameRizi}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"وضعیت برنامه ریزی برای کارها"}>
                                            <option value={"زیاد"}>کاملا برنامه‌ریزی شده</option>
                                            <option value={"متوسط"}>تا حدی برنامه‌ریزی شده</option>
                                            <option value={"کم"}>بدون برنامه‌ریزی مشخص</option>
                                            <option value={"هرگز"}>کاملا بی‌برنامه</option>

                                        </MDSelect>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Ravabet"
                                            name="Ravabet"
                                            value={formik.values.Ravabet}
                                            onChange={(r) => formik.setFieldValue("Ravabet", r)}
                                            error={
                                                Boolean(formik.errors.Ravabet)
                                            }
                                            helperText={formik.errors.Ravabet}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان روابط اجتماعی"}>
                                            <option value={"بسیار خوب"}>بسیار خوب</option>
                                            <option value={"خوب"}>خوب</option>
                                            <option value={"متوسط"}>متوسط</option>
                                            <option value={"ضعیف"}>ضعیف</option>
                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="RezayatKh"
                                            name="RezayatKh"
                                            value={formik.values.RezayatKh}
                                            onChange={(r) => formik.setFieldValue("RezayatKh", r)}
                                            error={
                                                Boolean(formik.errors.RezayatKh)
                                            }
                                            helperText={formik.errors.RezayatKh}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"میزان رضایت از وضعیت اقتصادی و  اجتماعی خانواده"}>
                                            <option value={"بسیار راضی"}>بسیار راضی</option>
                                            <option value={"نسبتاً راضی"}>نسبتاً راضی</option>
                                            <option value={"ناراضی"}>ناراضی</option>
                                            <option value={"بسیار ناراضی"}>بسیار ناراضی</option>

                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 13 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Taalol"
                                            name="Taalol"
                                            value={formik.values.Taalol}
                                            onChange={(r) => formik.setFieldValue("Taalol", r)}
                                            error={
                                                Boolean(formik.errors.Taalol)
                                            }
                                            helperText={formik.errors.Taalol}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"تعلل و به تعویق انداختن امور"}>
                                            <option value={"انجام کارها به موقع"}>انجام کارها به موقع</option>
                                            <option value={"گاهی به تعویق انداختن"}>گاهی به تعویق انداختن</option>
                                            <option value={"اغلب به تعویق انداختن"}>اغلب به تعویق انداختن</option>
                                            <option value={"همیشه به تعویق انداختن"}>همیشه به تعویق انداختن</option>
                                        </MDSelect>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Behdasht"
                                            name="Behdasht"
                                            value={formik.values.Behdasht}
                                            onChange={(r) => formik.setFieldValue("Behdasht", r)}
                                            error={
                                                Boolean(formik.errors.Behdasht)
                                            }
                                            helperText={formik.errors.Behdasht}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"نظم در مراقبت های فردی مانند استراحت و بهداشت"}>
                                            <option value={"زیاد"}>بسیار منظم</option>
                                            <option value={"متوسط"}>نسبتاً منظم</option>
                                            <option value={"کم"}>نامنظم</option>
                                            <option value={"هرگز"}>بسیار نامنظم</option>
                                        </MDSelect>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="RabteDustan"
                                            name="RabteDustan"
                                            value={formik.values.RabteDustan}
                                            onChange={(r) => formik.setFieldValue("RabteDustan", r)}
                                            error={
                                                Boolean(formik.errors.RabteDustan)
                                            }
                                            helperText={formik.errors.RabteDustan}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"نوع رابطه با دوستان"}>
                                            <option value={"بسیار"}>بسیار صمیمی</option>
                                            <option value={"صمیمی"}>صمیمی</option>
                                            <option value={"کم"}>کم‌ارتباط</option>
                                            <option value={"هیج"}>بدون ارتباط</option>

                                        </MDSelect>

                                    </Grid>
                                </>}
                                {miniStep === 14 && <>
                                    <Grid item xs={12}>
                                        <MDSelect
                                            id="Moghabeli"
                                            name="Moghabeli"
                                            value={formik.values.Moghabeli}
                                            onChange={(r) => formik.setFieldValue("Moghabeli", r)}
                                            error={
                                                Boolean(formik.errors.Moghabeli)
                                            }
                                            helperText={formik.errors.Moghabeli}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            w={{xs: "100%", md: "100%", lg: "100%",}}
                                            label={"ميزان آشنايي با روشهاي مقابله با هيجانهاي ناخوشايند مانند خشم و استرس"}>
                                            <option value={"بسیار آشنا"}>بسیار آشنا</option>
                                            <option value={"نسبتاً آشنا"}>نسبتاً آشنا</option>
                                            <option value={"کم‌ آشنا"}>کم‌ آشنا</option>
                                            <option value={"ناآشنا"}>ناآشنا</option>
                                        </MDSelect>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <MDInput
                                            id="Tozihat"
                                            name="Tozihat"
                                            value={formik.values.Tozihat}
                                            onChange={formik.handleChange}
                                            error={
                                                Boolean(formik.errors.Tozihat)
                                            }
                                            helperText={formik.errors.Tozihat}
                                            autoComplete={"1"}
                                            disabled={loading}
                                            // width={"200px"}
                                            sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                            label={"توضیحات اضافی"}/>
                                    </Grid>
                                </>}

                                <Grid item xs={12} textAlign={"start"}>
                                    <ButtonBase onClick={() => handleNextStep()}
                                                sx={{
                                                    background: "#0BE1B1",
                                                    width: "100%",
                                                    borderRadius: "5px",
                                                    height: 50
                                                }}
                                                disabled={loading}
                                                type={"button"}>
                                        <MDBox width={"100%"} py={2}>
                                            <MDTypography color={"black"} fontWeight={"bold"} fontSize={"20px"}>
                                                مرحله بعد
                                            </MDTypography>
                                        </MDBox>
                                    </ButtonBase>

                                </Grid>
                            </Grid>
                        </MDBox>
                        <MDBox sx={{
                            width: "50%",
                            justifySelf: "end",
                            textAlign: "center"
                        }}>
                            <ButtonBase onClick={() => handleBazgasht()}
                                        sx={{borderRadius: "5px", height: 50,}}
                                        disabled={loading}
                                        type={"button"}>
                                <MDTypography color={"black"} fontSize={"25px"} sx={{mr: 0}}>
                                    بازگشت
                                </MDTypography>
                            </ButtonBase>
                        </MDBox>
                        <MDBox sx={{
                            py: 5,
                            width: "100%",
                            display: "flex",
                            placeContent: "end",
                            alignItems: "center",
                            flexDirection: {xs: "column", md: "unset", xl: "unset"},
                            position: {xs: "unset", md: "relative", xl: "relative"}
                        }}>
                            <MDBox component={"img"} src={CurrentUser().user.Sex === "F" ? LFMAImage : LFFEImage}
                                   sx={{
                                       height: {xs: "30vh", md: "30vh", xl: "30vh"},
                                       position: {xs: "unset", md: "fixed", xl: "absolute"},
                                       left: 0,
                                       bottom: {xs: "unset", md: "0", xl: "55px"}
                                   }}/>
                            <MDBox sx={{width: "100%", border: "1px solid black", position: {xs: "relative", md: "absolute", xl: "absolute"},top:{xs: "20px", md: "unset", xl: "unset"}}}/>
                            <Stepper nonLinear alternativeLabel activeStep={activeStep} sx={{width: "50%"}}>
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepButton color="inherit" onClick={handleStep(index)}/>

                                    </Step>
                                ))}
                            </Stepper>
                        </MDBox>
                    </>}
                </MDBox>

            </> : <>
                <Grid container direction={"column"} textAlign={"center"} sx={{py: "4rem"}}>
                    <Grid item>
                        <MDTypography
                            sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>مرحله
                            تکمیل شد</MDTypography>
                    </Grid>
                    <Grid item>
                        <img src={CurrentUser().user.Sex === "F" ? LFMAImage : LFFEImage} style={{height: "60vh"}}/>
                    </Grid>
                    <Grid item>
                        <MDTypography
                            sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>آماده
                            ای برای مرحله بعد؟</MDTypography>

                    </Grid>
                    <Grid item>
                        <ButtonBase onClick={handleChangeMStep}
                                    sx={{background: "#FF4D00", borderRadius: "5px", height: 50, py: 5, px: 10}}
                                    disabled={loading}
                                    type={"button"}>
                            <MDBox width={"100%"} py={2}>
                                <MDTypography color={"white"} fontWeight={"bold"} fontSize={"50px"}>
                                    بزن بریم
                                </MDTypography>
                            </MDBox>
                        </ButtonBase>
                    </Grid>
                </Grid>


            </>}

        </HeroLayout>
    )
}